import React from 'react';
import classNames from 'classnames';
import cls from './FinancialIndicatorsEmptyBlock.module.css';
import { useFinancialIndicatorsEmptyBlock } from './useFinancialIndicatorsEmptyBlock';

interface FinancialIndicatorsEmptyBlockProps {
    classes?: string;
    isArchived?: boolean;
}

export const FinancialIndicatorsEmptyBlock = ({
    classes,
    isArchived,
}: FinancialIndicatorsEmptyBlockProps) => {
    const { is_customer } = useFinancialIndicatorsEmptyBlock();
    return (
        <div className={classNames(cls.FinancialIndicatorsEmptyBlock, [classes])}>
            {isArchived ? (
                <div className={cls.Content}>
                    <>{i18next.t('FinancialIndicatorsEmptyBlock.return.isArchived')}</>
                </div>
            ) : (
                <div className={cls.Content}>
                    {is_customer ? (
                        <>
                            {i18next.t('FinancialIndicatorsEmptyBlock.return.isCustomer.part1')}
                            <br />
                            {i18next.t('FinancialIndicatorsEmptyBlock.return.isCustomer.part2')}
                        </>
                    ) : (
                        <>
                            {i18next.t('FinancialIndicatorsEmptyBlock.return.content.part1')}
                            <br />
                            {i18next.t('FinancialIndicatorsEmptyBlock.return.content.part2')}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};
